<ng-container>
    <div *ngIf="hotel" class="hotel-resume">
        <div class="hotel-informations" (click)="getQuotes(hotel)">
            <div class="icon-name">
                <fa-icon [icon]="iconBed" class="icon-bed"></fa-icon>
                <div>
                    <h2 *ngIf="hotel.name" class="name">
                        {{ (hotel | transformHotelName).name }}<!--
                    -->
                        <ng-container *ngIf="isBrandReferenced()"><!--
                    -->&nbsp;<!--
                    --><fa-icon [icon]="iconCheck" [title]="getBrandName()"></fa-icon>
                        </ng-container>
                    </h2>
                    <div>
                        <ng-container *ngIf="hotel.address">
                            <address-component displayInline="true"
                                               [property]="hotel.address | transformAddress"></address-component>
                        </ng-container>
                        <a *ngIf="hotelSite()" [attr.href]="!hasRefreshError ? hotelSite() : null" target="_blank"
                           class="website-link">
                            {{ wording.webSite }}
                        </a>
                    </div>
                </div>
            </div>

            <div class="rating">
                <!-- hotel?.rating?['standardisationBody'] is used in quote search response (deprecated) -->
                <!-- hotel?.rating?.standard?.value is used in getproperty -->
                <rating [rating]="(hotel?.rating && hotel.rating['standardisationBody']) || hotel?.rating?.standard?.value"
                        [max]="maxNumberOfStars | async"></rating>
            </div>

            <div class="price-cancellation">
                <div class="host-cancellation">
                    <ng-container *permissionIf="permissions.SHARED_HOST_SHOW">
                        <div *ngIf="hotel.host && isString(hotel.host)" class="host">
                            {{ hotel.host | hostAlias | async }}
                            <ng-container *ngIf="hotel.alternative?.length">
                                <sup [attr.title]="getAlternativeNames(hotel.alternative)">+ {{ hotel.alternative?.length }}</sup>
                            </ng-container>
                        </div>

                        <div *ngIf="hotel.hostCode && !isString(hotel.host)" class="host">
                            {{ hotel.hostCode | hostAlias | async }}
                        </div>
                    </ng-container>
                    <div *ngIf="directDisplay.date">
                        <span [innerHtml]="dateInfos()"></span>
                    </div>
                    <div *ngIf="directDisplay.duration">
                        <span [innerHtml]="durationInfos()"></span>
                    </div>

                    <request-status *ngIf="hotel.status === HotelQuoteStatus.Request"></request-status>

                    <meal-plan [name]="mealPlan?.name" [code]="mealPlan?.code"></meal-plan>

                    <cancellation-conditions class="cancellation"
                                             [dateLastCancellationWithoutPenalty]="hotel.dateLastCancellationWithoutPenalty"
                                             [currency]="currency"
                                             [price]="hotel?.total?.cost"
                                             [configSharedHotel]="configSharedHotel">
                    </cancellation-conditions>

                    <div class="names-with-fees" *ngIf="namesWithFeesQuantity">
                        <div class="name-with-icon">
                            <fa-icon [icon]="moneyIcon"></fa-icon>
                        </div>
                        <div>
                            <div class="name-with-title" [ngPlural]="namesWithFeesQuantity">
                                <ng-template ngPluralCase="=1">{{wording.roomWithFees}}</ng-template>
                                <ng-template ngPluralCase="other">{{wording.roomsWithFees}}</ng-template>
                            </div>
                        </div>

                    </div>

                </div>

                <div class="price">
                    <ng-container *ngIf="showCostPricePermission && hotel?.total?.cost">
                        <div *ngIf="showCostPricePermission && showRetailPricePermission && hotel?.total?.retail">{{wording.costPrice}}</div>
                        <price-details [cost]="hotel?.total?.cost"
                                       [currencies]="currencies">
                        </price-details>
                        <delta-price
                                *ngIf="oldHotel"
                                [price]="hotel?.total?.cost"
                                [oldPrice]="oldHotel?.total?.cost" [currency]="this.currency"></delta-price>
                    </ng-container>

                    <ng-container *ngIf="showRetailPricePermission && hotel?.total?.retail">
                        <div *ngIf="showRetailPricePermission && showCostPricePermission && hotel?.total?.cost" class="retail-price-label">{{wording.retailPrice}}</div>
                        <price-details [cost]="hotel.total.retail"
                                       [currencies]="currencies">
                        </price-details>
                    </ng-container>

                </div>
            </div>
        </div>
        <div class="rooms" *ngIf="namesAndOccurencesList?.length && isShowRooms">
            <ul class="names">
                <li class="name-with" *ngFor="let name of namesAndOccurencesList">- {{name}}</li>
            </ul>
        </div>
    </div>
</ng-container>
